import _ from 'lodash';
import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';
import ApplicationConstants from '../constants/ApplicationConstants';
import Validators from '../utils/Validators.js';

const CHANGE_EVENT = 'change';
const Constants = SelectCustomerConstants;
const ActionTypes = Constants.ActionTypes;
const ApplicationActionTypes = ApplicationConstants.ActionTypes;

let _clientOin,
    _productId,
    _errorList = [],
    _canForwardFromClientOin = false;

function setProductId(productId) {
    _productId = productId;
}

function validateField(field) {
    let rules = field.validationRules;
    if (!rules) {
        Validators.clearErrorListForField(_errorList, field.id);
        return;
    }
    else {
        let data = {};
        data[field.model] = field.value;
        Validators.validateField(data, rules, field.customAttributeNames, _errorList, field.id, field.model);
    }
}

function updateClientOin(clientOin) {
    _canForwardFromClientOin = false;
    _clientOin = clientOin;
    const field = _.assign(Constants.ClientOin, { value: clientOin });
    validateField(field);
}

function validateClientOin() {
    const field = _.assign(Constants.ClientOin, { value: _clientOin });
    validateField(field);
    _canForwardFromClientOin = _errorList && _errorList.length === 0;
}

class ClientOinStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getClientOin() {
        return _clientOin;
    }

    getErrorList() {
        return _errorList;
    }

    getCanForwardFromClientOin() {
        return _canForwardFromClientOin;
    }

    getProductId() {
        return _productId;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ClientOinStore = new ClientOinStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ClientOinStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.UPDATE_CLIENT_OIN:
            updateClientOin(action.clientOin);
            break;

        case ActionTypes.FORWARD_FROM_CLIENT_OIN:
            validateClientOin();
            break;

        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            break;

        default:
            return true;
    }

    ClientOinStore.emitChange();
    return true;
});

export default ClientOinStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ClientOinStore.js